import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  avatar: {
    borderRadius: '2px',
    borderStyle: 'solid',
    borderWidth: '1px',
    cursor: 'pointer',
    '&:hover': {
      borderColor: theme.palette.primary.main,
    },
  },
  container: {
    borderRadius: theme.spacing(1),
    padding: theme.spacing(2),
    maxWidth: '300px',
    height: '100%',
  },  
  file_unknown: {
    alignContent: 'center',
    alignItems: 'center',
    borderColor: theme.palette.primary.main,
    borderRadius: theme.spacing(2),
    borderStyle: 'solid',
    borderWidth: '1px',
    display: 'flex',
    height: theme.spacing(8),
    justifyContent: 'center',
    margin: 'auto',
    width: theme.spacing(8),
  },
  file_container: {
    alignItems: 'center',
    borderColor: theme.palette.primary.main,
    borderRadius: '20px',
    borderStyle: 'dashed',
    borderWidth: '2px',
    display: 'flex',
    flexDirection: 'column',
    width: '300px',
    height: '200px',
    justifyContent: 'space-evenly',
    [theme.breakpoints.down('xs')]: {
      width: '230px',
    },
  },
  file_button: {
    width: '180px',
    height: '42.6px',
  },
  file_icon: {
    width: '50px',
    height: '50px',
  },
  upload_icon: {
    width: '60px',
    height: '60px',
    color: '#25D366',
    position: 'absolute',
    top: '70px',
    left: '120px',
  },
  preview: {
    width: '300px',
    height: '200px',
    position: 'relative',
  },
  preview_image: {
    width: '280px',
    height: '180px',
    position: 'absolute',
    top: '-8px',
    left: '10px',
    borderRadius: '10px',
  },
  preview_button: {
    position: 'absolute',
    top: '0',
    right: '0',
    marginRight: '15px',
    backgroundColor: '#fe0000',
  },
}));
